import { redirect } from 'react-router';

import { getCodingListsEntriesQuery, getCodingListsQuery } from '../../../queries/codingQuery';
import { companyPropertiesQuery } from '../../../queries/companyQuery';
import { selectedTeamIdQuery, teamQuery, teamsQuery } from '../../../queries/teamQuery';
import { userQuery } from '../../../queries/userQuery';

import type { QueryClient } from '@tanstack/react-query';
export const teamsCodingLoader = async ({ queryClient }: { queryClient: QueryClient }) => {
	const user = await queryClient.ensureQueryData(userQuery);
	const companyPropertiesData = await queryClient.ensureQueryData(
		companyPropertiesQuery(user?.companyAccountId, { cardprovider: 'tsgo-cardprovider' }),
	);
	const isHsbcCardProvider = companyPropertiesData?.cardprovider === 'HSBC';

	if (isHsbcCardProvider) {
		// we prevent the user from accessing the page if the card provider is HSBC
		throw redirect('/error');
	}

	const teamIdQuery = selectedTeamIdQuery('selectedTeamID');

	const teamId = await queryClient.ensureQueryData(teamIdQuery);
	const codingLists = await queryClient.ensureQueryData(getCodingListsQuery({ skipDisabled: true }));
	const codingEntries = await queryClient.ensureQueryData(
		getCodingListsEntriesQuery({
			codingLists,
		}),
	);

	return {
		teamId,
		codingLists,
		codingEntries,
		team: await queryClient.ensureQueryData(teamQuery({ teamId: teamId?.[0] || '' })),
		teams: await queryClient.ensureQueryData(teamsQuery({ state: 'active' })),
	};
};
